module.exports = __webpack_public_path__ + "img/bar-chart-view.5ecd0d9a.svg";